import React from 'react';
import './style.css';

interface CircularProps {
    testId?: string;
}

const Circular: React.FC<CircularProps> = ({ testId }) => (
    <div className='lds-dual-ring' data-testid={testId}></div>
);

export default Circular;
